import { displayFunctions } from '../../../utils/chartsUtils';

export const data = {
  plots: {
    favourites_count: {
      favourites_count: {
        trend: 1,
        values: [50, 80, 110, 90, 120, 70, 100],
        displayValue: displayFunctions.sum([50, 80, 110, 90, 120, 70, 100])
      }
    },
    followers_count: {
      addAdditionalPlots: true,
      followers_count: {
        trend: 1,
        values: [80, 100, 70, 130, 60, 110, 50],
        displayValue: displayFunctions.sum([80, 100, 70, 130, 60, 110, 50])
      }
    },
    friends_count: {
      friends_count: {
        trend: 1,
        values: [120, 150, 80, 140, 110, 100, 130],
        displayValue: displayFunctions.sum([120, 150, 80, 140, 110, 100, 130])
      }
    },
    listed_count: {
      listed_count: {
        trend: 1,
        values: [70, 100, 130, 90, 120, 80, 110],
        displayValue: displayFunctions.sum([70, 100, 130, 90, 120, 80, 110])
      }
    },
    statuses_count: {
      statuses_count: {
        trend: 1,
        values: [110, 140, 70, 130, 100, 90, 120],
        displayValue: displayFunctions.sum([110, 140, 70, 130, 100, 90, 120])
      }
    },

    additionalData: {
      posts_per_day: {
        trend: -1,
        values: [1, 0, 2, 1, 0, 0, 3],
        displayValue: 3
      }
    }
  },
  dates: getLastSevenDays()
};

function getLastSevenDays(): any {
  const dates = [];
  for (let i = 1; i < 8; i++) {
    const date = new Date();
    date.setDate(date.getDate() - i);
    dates.push(date.toISOString().split('T')[0] + 'T00:00:00+00:00');
  }
  return dates.reverse();
}
